import publicAPI from "../rest_handlers/publicAPI";
import {BRANCH_SIGNIN_URL, OWNER_SIGNIN_URL, USER_REFRESH_TOKEN} from "../configs/APIUrl";

export default class AuthService {

    static login = data => publicAPI.post(BRANCH_SIGNIN_URL, data);

    static ownerLogin = data => publicAPI.post(OWNER_SIGNIN_URL, data);

    static refreshToken = async refreshToken => {
        try {
            const res = await publicAPI.post(USER_REFRESH_TOKEN, null, {
                headers: {
                    'refresh-token': refreshToken
                }
            });
            return res.data;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

}
